function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "ICON"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Business_ic_mid",
  fill: "#666"
}, /*#__PURE__*/React.createElement("path", {
  d: "M96 144H82a2 2 0 110-4h14a2 2 0 110 4zM38 132c-18.42 0-38-5.08-38-14.5S19.58 103 38 103s38 5.08 38 14.5S56.42 132 38 132zm0-25c-9.4 0-18.21 1.26-24.8 3.55-5.67 2-9.2 4.63-9.2 6.95 0 4.38 12.93 10.5 34 10.5 9.4 0 18.21-1.26 24.8-3.55 5.67-2 9.2-4.63 9.2-6.95 0-4.38-12.93-10.5-34-10.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38 151.5c-17.22 0-32.3-4.1-37.52-10.2A2 2 0 010 140v-23a2 2 0 014 0v22.17c4.91 4.91 18.66 8.29 34 8.29 16.58 0 29.45-2.74 34-7.18V117.5a2 2 0 014 0v23.6a2 2 0 01-.48 1.3c-4.87 5.7-18.89 9.1-37.52 9.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46 172c-18 0-32.4-3.72-37.52-9.7A2 2 0 018 161v-16h4v15.17c4.74 4.68 18.19 7.79 34 7.79 17 0 29.59-2.53 34-6.79v-19.09c-.13-.74-1.53-2.08-6-2.08v-4c9.89 0 10 5.76 10 6v20a2 2 0 01-.48 1.3C77 170.87 57.23 172 46 172zm34-30a.39.39 0 000 .07z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116 160H82a2 2 0 110-4h34a12 12 0 0012-12V16a12 12 0 00-12-12H52a12 12 0 00-12 12v89a2 2 0 01-4 0V16A16 16 0 0152 0h64a16 16 0 0116 16v128a16 16 0 01-16 16z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Upgrade_notsignedoff_ic_mid",
  fill: "#e60000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M102 58a2 2 0 01-1.42-.59L84 40.83 67.41 57.42a2.001 2.001 0 11-2.83-2.83l18-18A1.92 1.92 0 0184 36a2 2 0 011.41.59l18 18A2 2 0 01102 58z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84 96a2 2 0 01-2-2V38a2 2 0 114 0v56a2 2 0 01-2 2z"
})));

var SvgTopUpMid = function SvgTopUpMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 172",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgTopUpMid;